// extracted by mini-css-extract-plugin
export default {"category":"Option_category__NNxF4","location":"Option_location__Tzcdi","scale":"Option_scale__+XuWI"};